import React from "react";
import { Redirect } from "react-router-dom";

const Home = () => <Redirect to="/search-identities-new" />;

export default Home;
